import React from 'react';

/** A hen/chicken silhouette in lucide-react's own visual style (24x24,
 * stroke-based, round caps/joins) since lucide has no literal chicken icon
 * (only Bird/Egg/Feather) — used for the Poultry nav item. */
export function ChickenIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* comb */}
      <path d="M13.5 5c.3-.8.1-1.6-.5-2 .8-.1 1.5.3 1.7 1.1.2-.7 1-1 1.7-.7-.4.6-.4 1.4 0 2" />
      {/* head + beak */}
      <circle cx="14.5" cy="7.5" r="2" />
      <path d="M16.3 8.3 18 9l-1.9.6" />
      {/* wattle */}
      <path d="M15 9.3v1.2" />
      {/* body */}
      <path d="M13 8.5c2 .3 3.5 2.1 3.5 4.3 0 2.6-2.5 4.7-6 4.7s-6.5-2.3-6.5-5.6C4 8.3 7 6 10.7 6c.9 0 1.7.2 2.3.6" />
      {/* tail feathers */}
      <path d="M4.3 11.5c-1-.3-1.8-1.1-2.1-2.2.9.2 1.8.7 2.4 1.5" />
      <path d="M4 9.8c-.6-.8-.7-1.9-.3-2.9.8.5 1.4 1.3 1.6 2.3" />
      {/* legs */}
      <path d="M9 17.5 8.3 20M8.3 20l-1 .3M8.3 20l.4 1" />
      <path d="M12.5 17.6 12 20M12 20l-1 .3M12 20l.5 1" />
    </svg>
  );
}
